import { ExtStatsActionI } from "./stats-action.result.ext";
import { ExtStatsActionQueryI } from "./stats-action.query.ext";
import { StatsActionI } from "./stats-action.result.int";
import { StatsActionQueryI } from "./stats-action.query.int";
import { nullToEmptyString } from "src/app/shared/helpers/shared-zero-to-null.function";

export const MapStatsAction = {
    mapQuery: (int: StatsActionQueryI): ExtStatsActionQueryI => {
        return {
            request: {
                app: nullToEmptyString(int.app),
                customer: nullToEmptyString(int.customer),
                action: nullToEmptyString(int.action),
                actionData: int.actionData ?? undefined,
                randomDeviceId: nullToEmptyString(int.randomDeviceId),
                username: nullToEmptyString(int.username),
            }
        };
    },
    mapResult: (_ext: ExtStatsActionI, _params): StatsActionI => {
        return {

        };
    }
};
